import { render } from "./tmReg.vue?vue&type=template&id=1faeb717&scoped=true"
import script from "./tmReg.vue?vue&type=script&lang=js"
export * from "./tmReg.vue?vue&type=script&lang=js"

import "./tmReg.vue?vue&type=style&index=0&id=1faeb717&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1faeb717"]])

export default __exports__